import { useMutation } from '@tanstack/react-query';
import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type CreatePaymentSessionResponse = {
  id: string;
  payment_session_secret: string;
  // full payment session object returned by Checkout, passed to Flow
  session: Record<string, unknown>;
};

type Params = {
  credits: number;
  store_id: number;
};

export const useCreatePaymentSession = (
  options: MutationOptions<CreatePaymentSessionResponse, Params>
) =>
  useMutation({
    mutationFn: async (sessionData) => {
      const { data } = await api.post<ApiResponse<CreatePaymentSessionResponse>>(
        '/purchase/session',
        sessionData
      );

      return data.data;
    },

    ...options,
  });
